module.exports = __webpack_public_path__ + "img/c4.dbbe3f05.jpg";